import {axiosInstanceTokenV2, axiosInstanceToken} from "../../../../app/api";
import {
    IConfirmCodeProps, IConfirmCodeResult,
    IGetAvatarResponse,
    IGetCitizenshipResponse,
    IGetExternalResponse,
    IGetIdentityCardResponse,
    IGetIdentityCardTypeResponse,
    IGetSnilsResponse,
    IIdentityCardRequest,
    IIdentityCardTypeRequest, IInitiateDataChangeProps, IInitiateDataChangeResult,
    IPersonalInfoRequest,
    IPersonResponse, IRepeatCodeProps, ISetNewPhoneProps, ISetNewPhoneResult,
    ISexResponse,
    ISnilsRequest,
    IUserResponse
} from "../../../../interface/Passport/Account/backend";
import moment from "moment";
import {IForeignPassportInput, IPassportInput,} from "../Modals/ChangePassport";
import {IPersonalInfo} from "../../../../interface/Passport/Account/frontend";
import {IdentityCardTypeEnum} from "../../../../enum/identityCardTypeEnum";

export async function getUser(): Promise<IUserResponse> {
    return axiosInstanceToken.get('/user/me').then(result => result.data)
}

export async function getSnils(): Promise<IGetSnilsResponse> {
    return axiosInstanceToken.get<IGetSnilsResponse>('/person/snils').then(result => result.data)
}

export async function getExternalAccounts(): Promise<IGetExternalResponse> {
    return axiosInstanceTokenV2.get<IGetExternalResponse>('/verification').then(result => result.data)
}

export async function patchSnils(data: ISnilsRequest): Promise<IGetSnilsResponse> {
    return axiosInstanceToken.patch<IGetSnilsResponse>('/person/snils', data).then(result => result.data)
}

export async function getIdentityCard(): Promise<IGetIdentityCardResponse> {
    return axiosInstanceToken.get<IGetIdentityCardResponse>('/person/identity-card').then(result => result.data)
}

export async function getCitizenship(): Promise<IGetCitizenshipResponse> {
    return axiosInstanceToken.get<IGetCitizenshipResponse>('/citizenship').then(result => result.data)
}

export async function getIdentityCardType(data?: IIdentityCardTypeRequest): Promise<IGetIdentityCardTypeResponse> {
    const params = new URLSearchParams()

    if (data?.id) {
        params.append('filter[citizenship_id]', data.id.toString())
    }

    return axiosInstanceToken.get<IGetIdentityCardTypeResponse>('/identity-card-type', {params: params}).then(result => result.data)
}

export async function patchIdentityCard(data: IPassportInput | IForeignPassportInput): Promise<IGetIdentityCardResponse> {
    let dataResponse: IIdentityCardRequest = {
        citizenship_id: data.citizenship_id,
        identity_card_type_id: data.identity_card_type_id,
        series: null,
        number: data.number,
        issued_by: null,
        department_code: null,
        issued_at: moment(data.issued_at).format('YYYY-MM-DD'),
        expires_at: null,
    }

    if (data.identity_card_type_id === IdentityCardTypeEnum.Passport) {
        const passportData = data as IPassportInput
        dataResponse = {
            ...dataResponse,
            series: passportData.series,
            issued_by: passportData.issued_by,
            department_code: passportData.department_code,
        }
    } else if (data.identity_card_type_id === IdentityCardTypeEnum.ForeignPassport) {
        const foreignPassportData = data as IForeignPassportInput
        dataResponse = {
            ...dataResponse,
            number: foreignPassportData.number,
            expires_at: moment(foreignPassportData.expires_at).format('YYYY-MM-DD'),
            issued_at: moment(foreignPassportData.issued_at).format('YYYY-MM-DD')
        }
    }

    return axiosInstanceToken.put<IGetIdentityCardResponse>('/person/identity-card', dataResponse).then(result => result.data)
}

export async function patchPerson(data: IPersonalInfo): Promise<IPersonResponse> {
    const dataResponse: IPersonalInfoRequest = {
        name: data.name,
        surname: data.surname,
        patronymic: data.patronymic ? data.patronymic : null,
        birthdate: data.birthdate ? moment(data.birthdate).format('YYYY-MM-DD') : null,
        sex_id: data.sex_id
    }
    return axiosInstanceToken.patch<IPersonResponse>('/person', dataResponse).then(result => result.data)
}

export async function getSex(): Promise<ISexResponse> {
    return axiosInstanceToken.get('/sex').then(result => result.data);
}

export async function getAvatar(): Promise<IGetAvatarResponse> {

    return axiosInstanceToken.get<IGetAvatarResponse>('/person/avatar').then(result => result.data)
}

export async function postAvatar(data: FormData): Promise<IGetAvatarResponse> {

    return axiosInstanceToken.post<IGetAvatarResponse>('/person/avatar', data).then(result => result.data)
}

export async function deleteAvatar(): Promise<undefined> {

    return axiosInstanceToken.delete<undefined>('/person/avatar').then(result => result.data)
}

export async function initiateChangeData(data :IInitiateDataChangeProps): Promise<IInitiateDataChangeResult> {

    return axiosInstanceToken.post<IInitiateDataChangeResult>('/contact-data/change/send-code', data).then(result => result.data)
}

export async function repeatCode(data :IRepeatCodeProps): Promise<IInitiateDataChangeResult> {

    return axiosInstanceToken.post<IInitiateDataChangeResult>('/contact-data/change/repeat-code', data).then(result => result.data)
}

export async function confirmCode(data :IConfirmCodeProps): Promise<IConfirmCodeResult> {

    return axiosInstanceToken.post<IConfirmCodeResult>('/contact-data/change/confirm-code', data).then(result => result.data)
}

export async function setNewPhone(data :ISetNewPhoneProps): Promise<ISetNewPhoneResult> {

    return axiosInstanceToken.post<ISetNewPhoneResult>('/phone/change', data).then(result => result.data)
}
